import React from 'react';
import { Link } from 'react-router-dom';

const AreasSection = ({ currentArea }) => {
  const areas = [
    'Milton Keynes',
    'Bletchley', 
    'Buckingham',
    'Princes Risborough',
    'Tingewick',
    'Wendover',
    'Weston Turville',
    'Haddenham',
    'Long Crendon',
    'Woburn'
  ];

  const formatAreaForUrl = (area) => {
    return area.toLowerCase().replace(/\s+/g, '-');
  };

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Areas We Cover Around {currentArea}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional cleaning services across Buckinghamshire and surrounding areas
          </p>
        </div>

        <div className="text-center mb-12">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4">
            {areas.map((area, index) => (
              <Link
                key={index}
                to={`/home/${formatAreaForUrl(area)}`}
                className="text-lg font-medium text-blue-600 hover:text-blue-800 hover:underline transition-all duration-200 decoration-2 underline-offset-4"
                onClick={handleLinkClick}
              >
                {area}
              </Link>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Don't see your area listed? We may still be able to help!
          </p>
          <a
            href="tel:07878522378"
            className="inline-flex items-center space-x-2 bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold"
          >
            <span>Call to Check Coverage: 07878 522378</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AreasSection;